import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".mySwiper", {
    spaceBetween: '20%',
    slidesPerView: 5,
     breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        spaceBetween: '20%',
        slidesPerView: 5,
      },
      768: {  //当屏幕宽度小于等于768
        spaceBetween: '20%',
        slidesPerView: 4,
      },
      320: {  //当屏幕宽度小于等于320
        spaceBetween: '20%',
        slidesPerView: 3,
      }
    } 
});
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});
